export type Source = {
	id: number;
	url: string;
	date: string;
	outdated: boolean;
	position?: number;
	verified_article?: boolean;
};

export interface SourceData {
	image?: string;
	title?: string;
	site?: string;
	domain?: string;
	url: string;
	icon?: string;
	description?: string;
}

export interface ErrorSource {
	error: string;
	url: string;
	domain?: string;
}

export interface QuestionResponse {
	q: string[];
}

export type FullSource = SourceData | ErrorSource;

export interface Question {
	id: string;
	title: string;
	url: string;
	clicks?: number;
}

export enum FeedbackEnum {
	LIKE = 'like',
	DISLIKE = 'dislike'
}
export interface SourceURLFeedback {
	url: string;
	id: number;
	feedback: FeedbackEnum | undefined;
}

export enum FromMessageEnum {
	BOT = 'bot',
	USER = 'user'
}

interface BasicMessage {
	id: string;
	text: string;
	file?: string;
	from: FromMessageEnum;
	created_time: string;
}

export interface BotMessage extends BasicMessage {
	feedback: FeedbackEnum | null;
	sources: Source[];
	internetSources: Source[];
	completed: boolean;
	from: FromMessageEnum.BOT;
	outdated: boolean;
	error?: boolean;
	internetText: string;
}

export interface UserMessage extends BasicMessage {
	from: FromMessageEnum.USER;
}

export type Message = UserMessage | BotMessage;

export type CopySources = 'copied.button' | 'copied.share' | null;

export enum Errors {
	model_validation_error = 'error-back',
	too_many_tokens_error = 'error-too-many-tokens',
	llm_completion_error = 'error-providers',
	prompt_build_error = 'error-prompt-build',
	question_not_found_error = 'error-question-not-found',
	retrieve_history_error = 'error-retrieve-history',
	unlink_feedback_error = 'error-unlink-feedback',
	link_feedback_error = 'error-link-feedback',
	get_shared_chat_error = 'error-get-shared-chat',
	error = 'error'
}
